import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { onChangeParkingFilter1300 } from '../../../ac/onChangeMapFilters';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { PARKING_1300_FILTER } from '../../../constants/filterStyles';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const ParkingFiltersComponent = ({
    mapFilters,
    onChangeParkingFilter1300,
}) => {
    // ✅ НОВАЯ АРХИТЕКТУРА: использование стилей из filterStyles
    let items = PARKING_1300_FILTER.items;
    if (PARKING_1300_FILTER.style && PARKING_1300_FILTER.styleKey) {
        items = getStyleFilterItems(PARKING_1300_FILTER.style, PARKING_1300_FILTER.styleKey);
    }
    const { reduxPath } = PARKING_1300_FILTER;
    const filterStatuses = mapFilters[reduxPath] || [];

    return (
        <div>
            <div className={styles.legHead}>{t`Статус парковки по 1300 постановлению`}:</div>
            <div className={styles.checkboxIconGrid}>
                {
                    items.map(({ value, color, label }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width='2vw'
                                height='2vw'
                                opacity='0.8'
                            />
                            <label htmlFor={label && label.id ? label.id : value}>
                                {typeof label === 'string' ? label : (label && i18n._(label))}
                            </label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type='checkbox'
                                        name='parkings'
                                        id={value}
                                        checked={filterStatuses.includes(value)}
                                        value={value}
                                        onChange={onChangeParkingFilter1300}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>
            <br/>
            <div className={styles.dataDescription}>{t`Данные из таблицы`} public.parkings</div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeParkingFilter1300 })(ParkingFiltersComponent);

export const ParkingFilters1300 = withDisplayedLayersCheck(ConnectedComponent, t`Парковки (1300)`);
